/*
  Povellea Private List pop-up (sections/pv-private-list.liquid).
  Apply pack 2026-10-01, change C01. Vanilla JS, no libraries, loaded with defer.

  Behaviour
  - Opens once after the delay set in the section (default 15 s).
  - After the visitor closes it, it stays hidden for the number of days set in
    the section (default 30). After a successful join it never opens again.
  - Consent 1 (emails) must be ticked; consent 2 (Meta ads) only adds the tag
    consent-meta-ads.
  - A submit reloads the page (Shopify customer form). The dialog reopens to
    show the result ONLY when this browser submitted the Private List form in
    the last 10 minutes: the footer newsletter is also a customer form, and its
    customer_posted=true must not open this dialog or mark the visitor as joined.
  - Never interrupts another open dialog (cart drawer, menu, search).
  - In the theme editor it opens when the section is selected.
*/
(function () {
  'use strict';

  var STORE_KEY = 'pvPrivateList';
  var RECENT_SUBMIT_MS = 10 * 60 * 1000;

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(STORE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(state));
    } catch (e) {
      /* storage blocked: the pop-up follows the delay rule again next visit */
    }
  }

  function daysSince(ts) {
    if (!ts) return Infinity;
    return (Date.now() - ts) / 86400000;
  }

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('pv-pl-open');
    var focusTarget =
      dialog.querySelector('[data-pv-pl-done] [tabindex="-1"]') || dialog.querySelector('input[type="email"]');
    if (focusTarget) {
      window.setTimeout(function () {
        focusTarget.focus();
      }, 30);
    }
  }

  function closeDialog(dialog, remember) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('pv-pl-open');
    if (remember) {
      var state = readState();
      state.closedAt = Date.now();
      writeState(state);
    }
  }

  function setupForm(dialog) {
    var form = dialog.querySelector('form');
    if (!form) return;
    var email = form.querySelector('input[type="email"]');
    var consentEmail = form.querySelector('[data-pv-pl-consent-email]');
    var consentAds = form.querySelector('[data-pv-pl-consent-ads]');
    var tags = form.querySelector('[data-pv-pl-tags]');
    var errEmail = form.querySelector('[data-pv-pl-error-email]');
    var errConsent = form.querySelector('[data-pv-pl-error-consent]');
    var baseTags = tags ? tags.value : '';

    form.addEventListener('submit', function (event) {
      var emailValid = !!(email && email.value.trim() !== '' && email.checkValidity());
      var consentGiven = !!(consentEmail && consentEmail.checked);

      if (errEmail) errEmail.hidden = emailValid;
      if (email) {
        if (emailValid) {
          email.removeAttribute('aria-invalid');
        } else {
          email.setAttribute('aria-invalid', 'true');
        }
      }
      if (errConsent) errConsent.hidden = consentGiven;

      if (!emailValid || !consentGiven) {
        event.preventDefault();
        var firstBad = !emailValid ? email : consentEmail;
        if (firstBad) firstBad.focus();
        return;
      }

      if (tags) {
        tags.value = baseTags + (consentAds && consentAds.checked ? ',consent-meta-ads' : '');
      }
      var state = readState();
      state.submittedAt = Date.now();
      writeState(state);
    });
  }

  function init() {
    var dialog = document.querySelector('[data-pv-pl]');
    if (!dialog) return;

    setupForm(dialog);

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-pv-pl-close]')) {
        closeDialog(dialog, true);
        return;
      }
      /* a click on the backdrop (outside the panel) closes */
      if (event.target === dialog) {
        closeDialog(dialog, true);
      }
    });

    dialog.addEventListener('cancel', function (event) {
      /* Escape key */
      event.preventDefault();
      closeDialog(dialog, true);
    });

    if (dialog.getAttribute('data-design-mode') === 'true') {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(dialog)) openDialog(dialog);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(dialog)) closeDialog(dialog, false);
      });
      return;
    }

    var state = readState();
    var recentSubmit = state.submittedAt && Date.now() - state.submittedAt < RECENT_SUBMIT_MS;

    if (recentSubmit) {
      var hasDone = !!dialog.querySelector('[data-pv-pl-done]');
      var hasServerError = !!dialog.querySelector('[aria-invalid="true"]');
      if (hasDone) {
        state.joinedAt = Date.now();
        delete state.submittedAt;
        writeState(state);
        openDialog(dialog);
        return;
      }
      if (hasServerError) {
        delete state.submittedAt;
        writeState(state);
        openDialog(dialog);
        return;
      }
    }

    if (state.joinedAt) return;
    var hideDays = parseInt(dialog.getAttribute('data-hide-days'), 10) || 30;
    if (daysSince(state.closedAt) < hideDays) return;

    /* Conversion fixes 2026-10-03 (Anas): the pop-up opens only after the visitor
       has scrolled past the consultation band (the "Still deciding?" banner whose
       button books a Design Consultation), or on the second page view of the visit.
       Never on arrival: the section's delay stays as a minimum time on the page, and
       the visitor must have scrolled. If another dialog or the menu is open at that
       moment, it waits for the next scroll instead of interrupting. */
    var delay = (parseInt(dialog.getAttribute('data-delay'), 10) || 15) * 1000;
    var delayPassed = false;
    var done = false;

    var views = 1;
    try {
      views = (parseInt(window.sessionStorage.getItem('pvPlViews'), 10) || 0) + 1;
      window.sessionStorage.setItem('pvPlViews', String(views));
    } catch (e) {
      /* no session storage: the band rule still applies */
    }

    var band = null;
    var bandLinks = document.querySelectorAll('.image-banner a[href*="/pages/contact"], .image-banner a[href*="/pages/design-consultation"], .image-banner a[href*="/pages/free-styling-consultation"]');
    if (bandLinks.length) {
      band = bandLinks[0].closest('.shopify-section') || bandLinks[0].closest('.image-banner');
    }

    function conditionMet() {
      var doc = document.documentElement;
      var y = window.pageYOffset || doc.scrollTop || 0;
      if (y <= 0) return false;
      if (views >= 2) return true;
      if (!band) return false;
      return band.getBoundingClientRect().bottom < 0;
    }

    function tryOpen() {
      if (done || !delayPassed || !conditionMet()) return;
      if (document.querySelector('dialog[open]:not([data-pv-pl])')) return;
      if (document.documentElement.classList.contains('overflow-hidden')) return;
      if (document.documentElement.classList.contains('pv-scroll-locked')) return;
      done = true;
      window.removeEventListener('scroll', onScroll);
      openDialog(dialog);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        tryOpen();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(function () {
      delayPassed = true;
      tryOpen();
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
